/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigPhoneNumberExtension
 */
export interface BidirectionalActionConfigPhoneNumberExtension {
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfigPhoneNumberExtension
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfigPhoneNumberExtension
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof BidirectionalActionConfigPhoneNumberExtension
     */
    max_length?: number;
}

/**
 * Check if a given object implements the BidirectionalActionConfigPhoneNumberExtension interface.
 */
export function instanceOfBidirectionalActionConfigPhoneNumberExtension(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function BidirectionalActionConfigPhoneNumberExtensionFromJSON(json: any): BidirectionalActionConfigPhoneNumberExtension {
    return BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigPhoneNumberExtension {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'max_length': !exists(json, 'max_length') ? undefined : json['max_length'],
    };
}

export function BidirectionalActionConfigPhoneNumberExtensionToJSON(value?: BidirectionalActionConfigPhoneNumberExtension | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'required': value.required,
        'max_length': value.max_length,
    };
}

